import { useSelectAll, useSelectedKeys } from "context/BulkActionsContext";

export function SelectAllCheckbox(): JSX.Element {
  const { selectAll, selectAllEnabled, setSelectAll, flipSelectAll } = useSelectAll();

  return (
    <div className="w-full flex cursor-pointer items-center justify-center" onClick={flipSelectAll}>
      <input
        type="checkbox"
        className="form-checkbox h-4 w-4  flex rounded-sm border border-gray-300 hover:border-primary-main hover:border-2 checked:text-primary-dark"
        checked={selectAllEnabled}
        onChange={flipSelectAll}
      />
    </div>
  );
}
